// Filtro de origen compartido entre tabs Ingresos y Análisis Mensual.
// Mantiene una sola fuente de verdad para "Todos / Tickets / Mensuales"
// — si cambia la lógica de qué entra en cada categoría, se cambia acá.

import React from "react";

export const SOURCE_OPTIONS = [
  { value: "all", label: "Todos", icon: "account_balance_wallet" },
  { value: "tickets", label: "Tickets", icon: "confirmation_number" },
  // "Abonados" y no "Mensuales": la pestana se llama "Analisis mensual" y este
  // boton estaba a 40 px, significando otra cosa completamente distinta.
  { value: "monthly", label: "Abonados", icon: "calendar_month" },
];

// Suma de ingresos atribuidos a tickets (hora + estadía + turno + tarifa plana
// + acuerdos). Acuerdos se cuentan como tickets porque son ingresos de un
// ticket específico aunque el cobro sea por convenio.
export const ticketsIncome = (d) =>
  (d?.tickets?.hour?.amount || 0)
  + (d?.tickets?.stay?.amount || 0)
  + (d?.tickets?.tn?.amount || 0)
  + (d?.tickets?.plana?.amount || 0)
  + (d?.deals?.amount || 0);

export const monthlyIncome = (d) => d?.monthly?.amount || 0;

// Aplica el filtro a un array de docs (diarios o mensuales). Sobreescribe
// `income` y, en el caso de "mensuales", también pone `expense=0` porque
// los egresos no se atribuyen a una fuente específica.
export const applySourceFilter = (docs, source) => {
  if (source === "all") return docs;
  return docs.map((d) => {
    if (source === "tickets") {
      return { ...d, income: ticketsIncome(d) };
    }
    return { ...d, income: monthlyIncome(d), expense: 0 };
  });
};

export const SourceSelector = ({ value, onChange }) => (
  <div className="d-flex align-items-center gap-1">
    <span
      className="text-muted me-1"
      style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5 }}
    >
      Origen:
    </span>
    {SOURCE_OPTIONS.map((opt) => (
      <button
        key={opt.value}
        className={`btn btn-sm ${value === opt.value ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => onChange(opt.value)}
        style={{ fontSize: 12, padding: "2px 8px" }}
      >
        <span
          className="material-symbols-rounded me-1"
          style={{ fontSize: 13, verticalAlign: "middle" }}
        >
          {opt.icon}
        </span>
        {opt.label}
      </button>
    ))}
  </div>
);
